import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { CheckoutSettingsService } from './services/CheckoutSettingsService';
import { fetchTranslations } from '../utils/fetchTranslations';
import { withResultObserver } from '@wix/function-result-observation';
import { RESULT_PROP_NAME } from '../utils/consts';
import { BIService } from './services/BIService';
import { SPECS } from './SPECS';
import { ExpressCheckoutButtonsState } from '../utils/ExpressCheckoutButtonsState';
import { ExpressCheckoutService } from './services/ExpressCheckoutService';
export class ExpressCheckoutButtonsController {
  constructor(controllerParams) {
    _defineProperty(this, "controllerParams", void 0);
    _defineProperty(this, "checkoutSettingsService", void 0);
    _defineProperty(this, "biService", void 0);
    _defineProperty(this, "controllerConfig", void 0);
    /** @deprecated */
    _defineProperty(this, "getCurrency", void 0);
    _defineProperty(this, "origin", void 0);
    _defineProperty(this, "expressCheckoutService", void 0);
    _defineProperty(this, "currency", void 0);
    _defineProperty(this, "checkoutId", '');
    _defineProperty(this, "latestTotalAmount", '0');
    _defineProperty(this, "wasShippingMethodSelected", false);
    _defineProperty(this, "priceVerificationToken", void 0);
    _defineProperty(this, "onShippingContactSelected", async shippingContact => {
      const result = await this.expressCheckoutService.onShippingContactSelected(this.checkoutId, shippingContact);
      if (!result.paymentData.error) {
        var _result$extraData;
        this.latestTotalAmount = result.paymentData.paymentAmount;
        this.priceVerificationToken = (_result$extraData = result.extraData) == null ? void 0 : _result$extraData.priceVerificationToken;
      }
      return result.paymentData;
    });
    _defineProperty(this, "onPaymentAuthorized", async (paymentAuthorizedArgs, shouldUpdateShippingAddress) => {
      return this.expressCheckoutService.onPaymentAuthorized(this.checkoutId, paymentAuthorizedArgs, {
        shouldUpdateShippingAddress,
        wasShippingMethodSelected: this.wasShippingMethodSelected,
        latestTotalAmount: this.latestTotalAmount,
        priceVerificationToken: this.priceVerificationToken
      }, {
        contentAppId: this.controllerParams.contentAppId,
        contentComponentId: this.controllerParams.contentComponentId,
        widgetId: this.controllerParams.widgetId
      });
    });
    _defineProperty(this, "onShippingMethodSelected", async shippingMethod => {
      var _result$extraData2;
      const result = await this.expressCheckoutService.onShippingMethodSelected(this.checkoutId, shippingMethod);
      this.latestTotalAmount = result.paymentData.paymentAmount;
      this.priceVerificationToken = (_result$extraData2 = result.extraData) == null ? void 0 : _result$extraData2.priceVerificationToken;
      this.wasShippingMethodSelected = true;
      return result.paymentData;
    });
    _defineProperty(this, "getInitialPaymentData", async () => {
      this.checkoutId = await this.controllerParams.getCheckoutId();
      const {
        paymentData: result,
        extraData
      } = await this.expressCheckoutService.getInitialPaymentData(this.checkoutId);
      this.latestTotalAmount = result.paymentAmount;
      this.priceVerificationToken = extraData.priceVerificationToken;
      return result;
    });
    _defineProperty(this, "onStateChange", _ref => {
      var _this$controllerParam, _this$controllerParam2;
      let {
        state,
        numberOfButtons
      } = _ref;
      (_this$controllerParam = (_this$controllerParam2 = this.controllerParams).onStateChange) == null || _this$controllerParam.call(_this$controllerParam2, {
        state,
        numberOfButtons
      });
      if (state !== ExpressCheckoutButtonsState.LOADING) {
        this.biService.reportExpressCheckoutButtonsPresented({
          origin: this.origin,
          numOfExpressButtonPresented: numberOfButtons
        });
      }
    });
    _defineProperty(this, "onCancel", () => {
      var _this$controllerParam3, _this$controllerParam4;
      this.wasShippingMethodSelected = false;
      return (_this$controllerParam3 = (_this$controllerParam4 = this.controllerParams).onCancel) == null ? void 0 : _this$controllerParam3.call(_this$controllerParam4);
    });
    _defineProperty(this, "init", async () => {
      var _this$controllerConfi, _this$controllerConfi2, _this$getCurrency2;
      const locale = this.getLocale();
      const [translations, expressCheckoutSettings] = await Promise.all([fetchTranslations(locale), this.checkoutSettingsService.getExpressCheckoutSettings()]);
      this.expressCheckoutService = new ExpressCheckoutService({
        expressCheckoutSettings,
        controllerConfig: this.controllerConfig,
        biService: this.biService,
        getCurrency: () => {
          var _this$getCurrency;
          return this.currency ?? ((_this$getCurrency = this.getCurrency) == null ? void 0 : _this$getCurrency.call(this));
        },
        locale,
        httpClient: this.controllerParams.httpClient,
        errorHandler: this.controllerParams.errorHandler,
        continueShoppingUrl: this.controllerParams.continueShoppingUrl,
        successUrl: this.controllerParams.successUrl
      });
      const domain = (_this$controllerConfi = this.controllerConfig.wixCodeApi) == null || (_this$controllerConfi = _this$controllerConfi.location) == null ? void 0 : _this$controllerConfi.baseUrl;
      const {
        appDefinitionId: appDefId,
        instanceId: appInstanceId,
        instance: appInstance
      } = this.controllerConfig.appParams || /* istanbul ignore next */{};
      const {
        metaSiteId,
        visitorId,
        ownerId: siteOwnerId
      } = ((_this$controllerConfi2 = this.controllerConfig.platformAPIs) == null ? void 0 : _this$controllerConfi2.bi) || /* istanbul ignore next */{};
      const meta = {
        appDefId,
        appInstanceId,
        siteId: metaSiteId,
        visitorId: visitorId,
        siteOwnerId,
        appInstance,
        consumerWidgetId: this.controllerParams.widgetId
      };
      const observe = withResultObserver(this.controllerConfig.setProps, {
        resultPropName: RESULT_PROP_NAME
      });
      const _expressCheckoutButtonsData = {
        legacyCurrency: (_this$getCurrency2 = this.getCurrency) == null ? void 0 : _this$getCurrency2.call(this),
        locale,
        domain,
        meta,
        translations,
        demoMode: this.controllerParams.demoMode,
        onCancel: this.onCancel,
        onClick: this.controllerParams.onClick ?? (() => {}),
        isExpressSupported: this.expressCheckoutService.isExpressSupported(),
        ...observe({
          onShippingContactSelected: this.onShippingContactSelected,
          onPaymentAuthorized: this.onPaymentAuthorized,
          onShippingMethodSelected: this.onShippingMethodSelected,
          getInitialPaymentData: this.getInitialPaymentData
        }),
        onStateChange: this.onStateChange,
        checkoutUIRevampOrderSummary: this.controllerConfig.essentials.experiments.enabled(SPECS.CheckoutUIRevampOrderSummary),
        setCurrency: currency => this.currency = currency
      };
      this.controllerConfig.setProps({
        _expressCheckoutButtonsData
      });
    });
    _defineProperty(this, "getLocale", () => {
      var _this$controllerConfi3, _ref2;
      const window = (_this$controllerConfi3 = this.controllerConfig.wixCodeApi) == null ? void 0 : _this$controllerConfi3.window;
      const fallbackLocale = (_ref2 = (window == null ? void 0 : window.locale) ?? (/* istanbul ignore next */window == null ? void 0 : window.browserLocale) ?? /* istanbul ignore next */'en') == null ? void 0 : _ref2.split('-')[0];
      return this.controllerParams.locale ?? fallbackLocale;
    });
    const {
      controllerConfig,
      getCurrency,
      origin
    } = controllerParams;
    this.controllerParams = controllerParams;
    this.checkoutSettingsService = new CheckoutSettingsService(controllerConfig);
    this.biService = new BIService(controllerConfig);
    this.controllerConfig = controllerConfig;
    this.getCurrency = getCurrency;
    this.origin = origin;
  }
}
//# sourceMappingURL=ExpressCheckoutButtonsController.js.map